import { CopyOutline, Gift, Send } from "../../svg/Settings";
import { Card } from "../../Card";
import Button from "../../button/Button";
import clsx from "clsx";
import { Loader } from "../../loader/Loader";
import { toast } from "sonner";
import CopyToClipboard from "react-copy-to-clipboard";
import { UserContext } from "../../context/UseContext";
import { useContext } from "react";
const About = [
  {
    type: "share",
    content:
      "Share your unique code with your friends. They sign up using your code.",
  },
  { type: "gift", content: "You automatically get 10 pts as reward." },
];

export const AboutReferrals = ({
  isLoading,
  points,
  loading,
  RedeemReferrals,
}) => {
  const { profile } = useContext(UserContext);
  return (
    <>
      <div
        style={{
          background: "linear-gradient(180deg, #0A0A0F 0%, #19256a 100%)",
        }}
        className=" bg-black gap-6 rounded-[10px] mt-5 mb-10"
      >
        <div className="flex justify-between items-center px-5">
          <div className=" py-5">
            <p className="text-white max-w-[192px] text-xl font-semibold mb-5">
              Refer a friend and earn 10 pts
            </p>
            <CopyToClipboard
              text={profile?.referrer_id ?? "No ID"}
              onCopy={() => {
                toast.success("Copied");
              }}
            >
              <div className="bg-[#ECEFFF] rounded-full border px-2.5 py-1 w-fit border-dashed border-primary-black flex items-center justify-between gap-1 cursor-pointer">
                <span className="text-primary-black text-sm">
                  {profile?.referrer_id ?? "No ID"}
                </span>
                <CopyOutline />
              </div>
            </CopyToClipboard>
          </div>
          <img
            className="max-w-[135px] object-contain "
            src="/image/coin.png"
            alt="redeem_cup"
            loading="lazy"
          />
        </div>
      </div>
      <Card className="mb-5">
        <p className="text-base text-primary-black font-semibold">
          How it works
        </p>
        <div className="flex flex-col gap-5 mt-5">
          {About.map((x, i) => {
            return (
              <div key={i} className="flex items-center gap-2.5">
                <div className="flex items-center justify-center p-1.5 rounded-md bg-[#ECEFFF]">
                  {x.type === "share" ? <Send /> : <Gift />}
                </div>
                <p className="text-xs text-primary-black font-normal">
                  {x.content}
                </p>
              </div>
            );
          })}
        </div>
      </Card>
      <Card className="mb-5">
        <p className="text-base text-primary-black font-semibold mb-5">
          Total earnings
        </p>
        {isLoading ? (
          <div className="h-[7dvh] flex items-center justify-center">
            <Loader type="spinningBubbles" color="#386be4d4" />
          </div>
        ) : (
          <div className="flex justify-between items-center bg-[#F8F8F8] p-2.5 rounded-full">
            <p className="text-base text-primary-black font-semibold ">
              Referral points:{" "}
              <span className="text-primary-main">{points} pts</span>
            </p>
            <Button
              onClick={() => {
                if (points > 10) {
                  RedeemReferrals();
                }
                return;
              }}
              text={
                loading ? (
                  <Loader
                    color="#ffff"
                    type="spinningBubbles"
                    height="20px"
                    width="20px"
                  />
                ) : (
                  "Claim"
                )
              }
              className={clsx(
                loading && "!px-3 !w-[57px]",
                "!shadow-none p-2.5 !text-sm",
                points < 10 && "claim_override"
              )}
            />
          </div>
        )}
      </Card>
    </>
  );
};
